export interface ContactInfoInterface {
  contactId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export class ContactInfo implements ContactInfoInterface {
  contactId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;

  constructor(contactInfo: ContactInfoInterface) {
    this.contactId = contactInfo.contactId || '';
    this.firstName = contactInfo.firstName || '';
    this.lastName = contactInfo.lastName || '';
    this.email = contactInfo.email || '';
    this.phone = contactInfo.phone || '';
  }

  getName() {
    return [this.firstName, this.lastName].filter(Boolean).join(' ');
  }

  getPhoneAndEmail() {
    return [this.phone, this.email].filter(Boolean).join(' | ');
  }
}
